/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal[_ngcontent-%COMP%]{position:fixed;top:0;left:0;z-index:2;width:100%;height:100%}.modal__content[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;z-index:1;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.modal__background[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;height:100%;cursor:pointer;background:#4568dc;opacity:.3}.modal__close[_ngcontent-%COMP%]{position:absolute;top:10px;right:10px;padding:0;border:none;background:0 0;font-size:27px;color:rgba(0,0,0,.2)}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/shared/components/modal/modal.component.styl.shim.ngstyle.js.pre-build-optimizer.js